<template>
    <div class="speed-info" :class="[{
        'speed-info--online': status === 'online',
        'speed-info--offline': status === 'offline',
    }]">
        <div class="speed-info__top">
            <div class="speed-info__text">
                <div class="speed-info__registration-number">{{ registrationNumber }}</div>
                <div class="speed-info__driver-name">{{ driverName }}</div>
            </div>
            <div class="speed-info__icons">
                <div class="speed-info__speed">
                    {{ formatSpeed }}
                </div>
                <div class="speed-info__heading" :style="{
                    transform: `rotate(${heading}deg)`
                }"></div>
            </div>
        </div>
        <div v-if="date" class="speed-info__date">
            {{ date ? dateFormat(date) : null }}
        </div>
        <div v-if="hasRequestVideoPermissions && (date || (isStreamingHardware && hardwareId && date && isHardwareOnline))" class="speed-info__buttons">
<!--            <div v-if="isStreamingHardware && hardwareId && date && isHardwareOnline" class="speed-info__button speed-info__button&#45;&#45;playback">-->
<!--                <sp-button @click.native="goToRemotePlayback" text="Remote playback" text-transform="none" icon="playback"></sp-button>-->
<!--            </div>-->
            <div v-if="date" class="speed-info__button">
                <sp-button @click.native="requestVideo" text="Request video" text-transform="none" icon="playback"></sp-button>
            </div>
        </div>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import { DeviceCommandApi, MediaRequestApi } from '@/api'
import { calculateSpeedOrDistanceUnit, formatDate } from '@/helpers/Utils'
import toast from '@/plugins/izitoast'
import router from '@/router/routes'
import moment from 'moment'

const deviceCommandApi = new DeviceCommandApi()

export default {
    name: 'SpeedInfoBubble',
    components: {
        SpButton
    },
    // data () {
    //     return {
    //         isHardwareOnline: false
    //     }
    // },
    props: {
        hasRequestVideoPermissions: {
            type: Boolean,
            required: false
        },
        speed: {
            type: Number,
            required: false
        },
        heading: {
            type: Number,
            required: false
        },
        date: {
            type: String,
            required: false
        },
        hardwareId: {
            type: String,
            required: true
        },
        latitude: {
            type: Number,
            required: true
        },
        longitude: {
            type: Number,
            required: true
        },
        registrationNumber: {
            type: String,
            required: true
        },
        driverName: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        getSpeedUnit: {
            type: Number,
            required: true
        },
        isHardwareOnline: {
            type: Boolean,
            required: true,
        },
        store: {
            type: [Object, String],
            required: false
        },
        updateVideoRequest: {
            type: Boolean
        },
        withOverlay: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        // deviceStatistics: {
        //     handler () {
        //         if (null == this.deviceStatistics || !this.deviceStatistics.hasOwnProperty('devicesOnline') || !this.hardwareId) {
        //             return null
        //         }
        //
        //         this.devicesOnline = this.deviceStatistics.devicesOnline
        //         this.isHardwareOnline = this.devicesOnline.includes(this.hardwareId)
        //
        //         console.log('SpeedInfoBubble::deviceStatistics', this.isHardwareOnline)
        //     },
        //     deep: true
        // }
    },
    computed: {
        // ...mapGetters({
        //     deviceStatistics: 'trackingModule/getDeviceStatistics'
        // }),
        formatSpeed () {
            return 0 === this.getSpeedUnit ? this.speed : calculateSpeedOrDistanceUnit(this.speed, 'mi')
        },
        isStreamingHardware () {
            if (!this.hardwareId) {
                return false
            }

            return '0' === this.hardwareId.charAt(0)
        }
    },
    methods: {
        async requestVideo () {
            if (!this.date) {
                // toast.error('Invalid date, cannot request video.')
                return
            }

            if (true === this.updateVideoRequest) {
                toast.success('Request video sent.')
                const response = await deviceCommandApi.requestVideo({
                    hardwareId: this.hardwareId,
                    date: this.date,
                    videoLengthInSeconds: 10,
                    positionMetadata: {
                        speedInKph: this.speed,
                        latitude: this.latitude,
                        longitude: this.longitude
                    },
                    withOverlay: this.withOverlay
                })
                if (response.isSuccess) {
                    moment(this.date).format('YYYY-MM-DD')

                    const mediasForCurrentDay = await this.getCurrentMedias()

                    if (mediasForCurrentDay.length) {
                        this.store.dispatch('trackingModule/updateCurrentJourneyMedia', mediasForCurrentDay)
                    }
                }
            }
        },
        async getCurrentMedias () {
            const mediaRequestApi = new MediaRequestApi()
            const mediaResponse = await mediaRequestApi.getMediaRequests({
                videoTimeFrom: moment(this.date),
                videoTimeTo: moment(this.date),
                hardwareId: this.hardwareId
            })

            if (mediaResponse.isSuccess) {
                return mediaResponse.payload.items.filter(x => moment(moment(x.dateRequested).format('YYYY-MM-DD')).isSame(this.store.getters['trackingModule/getDateInJourneyTab']))
            }
            return []
        },
        dateFormat (date) {
            return formatDate(date)
        },
        goToRemotePlayback () {
            router.push({ path: `media/remote-playback/${this.hardwareId}/${this.date}` })
        }
    }
}
</script>

<style scoped lang="scss">
.speed-info {
    padding: 10px 20px;
    min-width: 250px;
    border-left: 4px solid $inactive;
    background: $dark;

    &--online {
        border-left-color: #09B66D;
    }

    &--offline {
        border-left-color: $danger;
    }

    &__top {
        display: flex;
        justify-content: space-between;
    }

    &__text {
        line-height: 13px;
        min-width: 120px;
    }

    &__registration-number {
        color: white;
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
    }

    &__driver-name {
        color: white;
        font-size: 10px;
    }

    &__icons {
        display: flex;
        justify-content: space-around;
    }

    &__speed {
        border: 3px solid red;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        text-align: center;
        font-size: 10px;
        font-weight: bold;
        line-height: 27px;
        color: white;
    }

    &__heading {
        width: 30px;
        height: 30px;
        background: url('../../assets/icons/icon-speed.svg');
        margin-right: 7px;
        position: relative;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 11px;
        top: 0;
    }

    &__date {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        margin: 5px 0;
        color: $white;
    }
    &__button {
        flex-basis: 100%;

        &--playback {
            margin-bottom: 10px;
        }
    }
    &__buttons {
        display: inline-flex;
        flex-direction: column;
        width: 100%;
    }
}
</style>
